import { Location } from '@angular/common';
import { HttpEventType } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { UploadState } from 'src/app/shared/enums/upload-state.enum';
import { FileInfo, UploadFile } from 'src/app/shared/interfaces/file-info.interface';
import { UploadFileService } from 'src/app/shared/services/upload-file.service';

const mock: Array<UploadFile> = [
  new UploadFile(
    {
      id: 23454,
      name: 'example_updating_file',
      size: 12000,
    },
    new BehaviorSubject<number>(50),
    new BehaviorSubject<UploadState>(UploadState.uploading)
  ),
  new UploadFile(
    {
      id: 23434554,
      name: 'example_ready_file_1',
      size: 12000,
    },
    new BehaviorSubject<number>(0),
    new BehaviorSubject<UploadState>(UploadState.ready)
  ),
  new UploadFile(
    {
      id: 2345544,
      name: 'example_ready_file_2',
      size: 12000000,
    },
    new BehaviorSubject<number>(30),
    new BehaviorSubject<UploadState>(UploadState.ready)
  ),
  new UploadFile(
    {
      id: 23455444,
      name: 'example_ready_file_3',
      size: 120,
    },
    new BehaviorSubject<number>(100),
    new BehaviorSubject<UploadState>(UploadState.ready)
  ),
  new UploadFile(
    {
      id: 234,
      name: 'example_ready_file_3',
      size: 120,
    },
    new BehaviorSubject<number>(100),
    new BehaviorSubject<UploadState>(UploadState.canceled)
  ),
];

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss'],
})
export class AccountComponent {
  public allowedTypes: string[] = ['.png', '.jpeg', '.gif'];
  public fileDropError?: string;

  uploadingFiles: Array<UploadFile> = [...mock];

  constructor(private uploadService: UploadFileService, private location: Location) {}

  onFileSelected(file: File) {
    this.fileDropError = undefined;
    var newFile = new UploadFile({ name: file.name, size: file.size });

    // const _subcription = this.uploadService.uploadFile(file).subscribe({
    //   next: (event) => {
    //     console.log(event as any);
    //     if (event.type === HttpEventType.UploadProgress) {
    //       newFile.progress.next(event.loaded / event.total! * 100);
    //     }
    //     else if (event.type === HttpEventType.Response) {
    //       newFile.state.next(UploadState.ready)
    //       //TODO: Add file id setting in newFile.fileInfo.id
    //     }
    //     else if (event.type == HttpEventType.ResponseHeader) {
    //       newFile.requestSubsciption?.unsubscribe();
    //       //TODO: Delete when the file upload is ready
    //       newFile.state.next(UploadState.ready)
    //     }
    //   },
    //   error: (error) => {
    //     newFile.state.next(UploadState.canceled)
    //     console.error(error as any);
    //     newFile.requestSubsciption?.unsubscribe();
    //     newFile.requestSubsciption = undefined;
    //   }
    // })

    // newFile.requestSubsciption = _subcription;

    this.uploadingFiles.push(newFile);
  }

  onFileError(error: string) {
    this.fileDropError = error;
  }

  cancel(uploadFile: UploadFile) {
    uploadFile.requestSubsciption?.unsubscribe();
    this.uploadingFiles = this.uploadingFiles.filter(e => e !== uploadFile);
  }

  delete(fileInfo: FileInfo) {
    console.log(fileInfo);

    this.uploadingFiles = this.uploadingFiles.filter(e => e.fileInfo.id !== fileInfo.id);
  }

  goBack() {
    this.location.back();
  }
}
